const nftItems = [
  {
    name: "Dreamy Sky",
    imageUrl: "https://ipfs.io/ipfs/QmExample1/dreamy-sky.png",
    description: "몽환적인 하늘을 표현한 NFT",
    category: "예술",
    creator: "0x123...abc",
    price: "0.05 ETH",
  },
  {
    name: "Lo-fi Beats",
    imageUrl: "https://ipfs.io/ipfs/QmExample2/lofi-beats.gif",
    description: "공부용으로 좋은 lo-fi 음악 NFT",
    category: "음악",
    creator: "0x234...bcd",
    price: "0.1 ETH",
  },
  {
    name: "Digital Wave",
    imageUrl: "https://ipfs.io/ipfs/QmExample3/digital-wave.png",
    description: "디지털 아트의 물결",
    category: "예술",
    creator: "0x345...cde",
    price: "0.07 ETH",
  },
  {
    name: "Wooden Sculpture",
    imageUrl: "https://ipfs.io/ipfs/QmExample4/wood-sculpture.jpg",
    description: "전통 목공예를 NFT로!",
    category: "공예",
    creator: "0x456...def",
    price: "0.2 ETH",
  },
  {
    name: "Study with Me",
    imageUrl: "https://ipfs.io/ipfs/QmExample5/study.jpg",
    description: "공부를 유도하는 NFT 배경",
    category: "학습",
    creator: "0x567...ef0",
    price: "0.03 ETH",
  },
  {
    name: "Anime Clip",
    imageUrl: "https://ipfs.io/ipfs/QmExample6/anime-clip.mp4",
    description: "짧은 애니메이션 NFT",
    category: "영상",
    creator: "0x678...f01",
    price: "0.15 ETH",
  },
  {
    name: "Ambient Sound",
    imageUrl: "https://ipfs.io/ipfs/QmExample7/ambient.mp3",
    description: "배경음으로 좋은 NFT 사운드",
    category: "음악",
    creator: "0x789...012",
    price: "0.08 ETH",
  },
  {
    name: "Mystery Box",
    imageUrl: "https://ipfs.io/ipfs/QmExample8/mystery-box.png",
    description: "무엇이든 나올 수 있는 미스터리 NFT",
    category: "기타",
    creator: "0xabc...999",
    price: "0.12 ETH",
  },
  {
    name: "Dreamscape",
    imageUrl: "https://ipfs.io/ipfs/QmXExampleHash1",
    category: "예술",
    description: "몽환적인 색채의 디지털 아트.",
    creator: "0xAa1b...1234",
    price: "0.8 ETH"
  },
  {
    name: "Pixel Symphony",
    imageUrl: "https://ipfs.io/ipfs/QmXExampleHash2",
    category: "음악",
    description: "픽셀 아트와 함께하는 전자음악 NFT.",
    creator: "0xBe2c...5678",
    price: "0.5 ETH"
  },
  {
    name: "Motion Mirage",
    imageUrl: "https://ipfs.io/ipfs/QmXExampleHash3",
    category: "영상",
    description: "3D 애니메이션 기반 움직이는 NFT.",
    creator: "0xCd3d...9101",
    price: "1.2 ETH"
  },
  {
    name: "Clay Wonders",
    imageUrl: "https://ipfs.io/ipfs/QmXExampleHash4",
    category: "공예",
    description: "손으로 빚은 클레이 아트 NFT.",
    creator: "0xDf4e...1121",
    price: "0.4 ETH"
  },
  {
    name: "LearnChain 101",
    imageUrl: "https://ipfs.io/ipfs/QmXExampleHash5",
    category: "학습",
    description: "블록체인 기초 교육용 NFT 배지.",
    creator: "0xEf5f...3141",
    price: "무료"
  },
  {
    name: "CodeVerse",
    imageUrl: "https://ipfs.io/ipfs/QmXExampleHash6",
    category: "기타",
    description: "프로그래밍을 테마로 한 메타버스 속 캐릭터.",
    creator: "0xFa6g...5161",
    price: "0.7 ETH"
  },
  {
    name: "Aurora Bliss",
    imageUrl: "https://ipfs.io/ipfs/QmXExampleHash7",
    category: "예술",
    description: "오로라를 주제로 한 사진 NFT.",
    creator: "0xGa7h...7181",
    price: "1.5 ETH"
  },
  {
    name: "Retro Vibes",
    imageUrl: "https://ipfs.io/ipfs/QmXExampleHash8",
    category: "음악",
    description: "복고풍 사운드트랙 컬렉션 NFT.",
    creator: "0xHa8i...9202",
    price: "0.9 ETH"
  }
];

export default nftItems;
